<div class="d-flex" style="height: 100vh">
  <div class="data-empty p-0 m-auto">
    <img src="./assets/images/icons/404.png" />
    <div class="w-100 text-center">
      <h1>Something went wrong</h1>
      <p>Your request could not be processed</p>
    </div>
  </div>
</div>
